import { SlideHeader, StepList } from "../shared";
import { ASSETS } from "@/lib/assets";

export function Slide03Mechanism() {
  const STEPS = [
    { title: "Fill", desc: "Open the reservoir and fill it with your chosen lotion, gel or liquid." },
    { title: "Press", desc: "Press the reservoir face with two fingers." },
    { title: "Catch and apply", desc: "It dispenses into your other hand. Apply as directed." },
  ];
  return (
    <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center max-w-5xl" data-testid="pitch-slide-mechanism">
      <div>
        <SlideHeader n="03" label="The Mechanism" />
        <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-light tracking-tighter leading-[1.08] text-white">
          Fill it. Press it. Catch it. <span className="text-accent">Apply it.</span>
        </h2>
        <StepList testid="pitch-mechanism-steps" steps={STEPS} />
        <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-zinc-500 mt-6">
          Refillable 1 oz reservoir.
        </p>
      </div>
      <div className="flex items-center justify-center">
        <img
          src={ASSETS.fingerPressReservoir}
          alt="Pressing the WearSpray reservoir to dispense formulation"
          className="rounded-2xl border border-zinc-800 max-h-[420px] w-full object-cover"
          data-testid="pitch-mechanism-photo"
        />
      </div>
    </div>
  );
}
